module.exports = __webpack_public_path__ + "img/big-icon-eclipse.129422be.svg";